import Vue from 'vue'
import {
	MessageBox
} from 'element-ui'
var loading = '';
var setTime = '';
var setTimes = [];
export default {
	startLoading() {
		loading = Vue.prototype.$loading({
			lock: true,
			text: "Loading...",
			target: document.querySelector('.content') //设置加载动画区域
		});
	},
	endLoading() {
		loading.close();
	},
	isEmptyObject(obj) {
		for (var key in obj) {
			return false
		};
		return true
	},
	messageAlert(msg, title, btn) {
		MessageBox(msg, title, {
			confirmButtonText: btn
		});
	},
	tipsAlert(msg) {
		MessageBox(msg, "提示", {
			confirmButtonText: '确定'
		});
	},
	saveAlert() {
		MessageBox("保存成功", "提示", {
			confirmButtonText: '确定'
		});
	},
	editAlert() {
		MessageBox("修改成功", "提示", {
			confirmButtonText: '确定'
		});
	},
	delAlert() {
		MessageBox("删除成功", "提示", {
			confirmButtonText: '确定'
		});
	},
	isValidIP(ip) {
		let reg =
			/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
		return reg.test(ip);
	},
  getNowFormatDate() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  timing(fun, millisecond) {
    setTime = setInterval(() => {
      fun();
    }, millisecond);
    setTimes.push(setTime);
  },
  clearTime(){
    setTimes.forEach(function (item) {
      clearInterval(item);
    });
    setTimes = [];
  },
}



// WEBPACK FOOTER //
// ./src/utils/utils.js